import { annioBase2,annioGrafica,paisBase2,entidadBase2,municipioBase2,sensorBase2,pcFiltroBase2,panelInfo2,storyStatus } from '../../stores/storymaps'
import { getPaisTot2,getEntTot2,getMunTot2,getPaisTotAnp2,getEntTotAnp2,getMunTotAnp2,mapInterval, mapIntervaltipo } from '../../stores/storymaps'
import { getPaisTotForestal2,getEntTotForestal2,getMunTotForestal2 } from '../../stores/storymaps'
import { getTotPais, getTotEstado, getTotMunicipio } from '../../tools/service/index'
import { getTotPaisAnp, getTotEstadoAnp, getTotMunicipioAnp } from '../../tools/service/index'
import { getTotPaisForestal,getTotEstadoForestal,getTotMunicipioForestal } from '../../tools/service/index'
import { updatePloty } from '../../tools/ploty/index'
import { findEntidad,findEntidad2,changeBbox,changeBbox2,deleteIdentify,pruebasource,pruebasource2 ,changeFilter3 } from '../mapboxgl/index'
import { toolsMapInteraction } from '../../components/toolsMap/toolsMap-store'

let annio='';annioBase2.subscribe(value => {annio = value;});
let pais='';paisBase2.subscribe(value => {pais = value;});
let entidad='';entidadBase2.subscribe(value => {entidad = value;});
let municipio='';municipioBase2.subscribe(value => {municipio = value;});
let sensor='';sensorBase2.subscribe(value => {sensor = value;});
let pcFiltro='';pcFiltroBase2.subscribe(value => {pcFiltro = value;});
let annioGraf='';annioGrafica.subscribe(value => {annioGraf = value;});
let getPaisTot=[];getPaisTot2.subscribe(value => {getPaisTot = value;});
let getEntTot=[];getEntTot2.subscribe(value => {getEntTot = value;});
let getMunTot=[];getMunTot2.subscribe(value => {getMunTot = value;});

let getPaisTotAnp=[];getPaisTotAnp2.subscribe(value => {getPaisTotAnp = value;});
let getEntTotAnp=[];getEntTotAnp2.subscribe(value => {getEntTotAnp = value;});
let getMunTotAnp=[];getMunTotAnp2.subscribe(value => {getMunTotAnp = value;});

let getPaisTotForestal=[];getPaisTotForestal2.subscribe(value => {getPaisTotForestal = value;});
let getEntTotForestal=[];getEntTotForestal2.subscribe(value => {getEntTotForestal = value;});
let getMunTotForestal=[];getMunTotForestal2.subscribe(value => {getMunTotForestal = value;});

let interval='3';mapInterval.subscribe(value => {interval = value;});
let intervalTipo='3';mapIntervaltipo.subscribe(value => {intervalTipo = value;});
let toolsMap;toolsMapInteraction.subscribe(value => {toolsMap = value;});

let activateStatus=false
let entidadRef=''
let onChangefilter = () =>{
    if(activateStatus){
        storyStatus.update(param=>{
            param['filter']=true
            return param
        })
    }
}
export const onResetStory = async (annio='2022',idPais='1') => {
    annioBase2.set(annio)
    paisBase2.set(idPais)
    entidadBase2.set('')
    municipioBase2.set('')
    sensorBase2.set('modis')
    pcFiltroBase2.set('pcalor')
    annioGrafica.set('2020')
    mapInterval.set('3')
    mapIntervaltipo.set('3')
    activateStatus=false
    onChangePais()
    activateStatus=true
}
export const onStoryMaps = async () => {
    if(toolsMap[0]['nivelAdminFilter']===2){
        onChangeEntidad()
    }else if(toolsMap[0]['nivelAdminFilter']===3){
        onChangeMunicipio()
    }else{
        onChangeAnnio()
    }
    activateStatus=true
}
export const onChangeAnnio = async () => {
    try{
        let getInfo=[]
        let info,info2,info3,info4,info5;
        let ref1,ref2,ref3,ref4,ref5=''
        let services=[]

        onChangefilter()

        if(toolsMap[0]['nivelAdminFilter']===2){
            /*ref1=info2['total']
            ref3=`${info['nom_pais']}/${info2['nom_estado']}`
            updatePloty(annio,annioGraf,pais,entidad,municipio,2,sensor,pcFiltro)
            changeFilter3(annio,pais,entidad,intervalTipo,interval,1,2,sensor,pcFiltro)*/
            onChangeEntidad()
        }else if(toolsMap[0]['nivelAdminFilter']===3){
            getMunTot2.set(await getTotMunicipio({annio,pais,estado:entidad,sensor,pcFiltro}))
            if(pcFiltro==='anp'){
                getMunTotAnp2.set(await getTotMunicipio({annio,pais,estado:entidad,sensor,pcFiltro:'pcalor'}))
                getMunTotForestal2.set(await getTotMunicipioForestal({annio,pais,estado:entidad,sensor}))
            }else if(pcFiltro==='forestal'){
                getMunTotForestal2.set(await getTotMunicipio({annio,pais,estado:entidad,sensor,pcFiltro:'pcalor'}))
                getMunTotAnp2.set(await getTotMunicipioAnp({annio,pais,estado:entidad,sensor}))
            }else{
                getMunTotAnp2.set(await getTotMunicipioAnp({annio,pais,estado:entidad,sensor}))
                getMunTotForestal2.set(await getTotMunicipioForestal({annio,pais,estado:entidad,sensor}))
            }
            /*getTotMunicipioAnp({annio,pais,estado:entidad}),
            getTotMunicipioForestal({annio,pais,estado:entidad})*/
            info=getPaisTot.find(item => item['id_pais']==pais)
            info2=getEntTot.find(item => item['id_estado']==entidad)
            info3=getMunTot.find(item => item['id_mun']==municipio)
            info4=getMunTotAnp.find(item => item['id_mun']==municipio)
            ref4=info4==undefined?'Sin dato':info4['total']
            info5=getMunTotForestal.find(item => item['id_mun']==municipio)
            ref5=info5==undefined?'Sin dato':info5['total']
            updatePloty(annio,annioGraf,pais,entidad,municipio,3,sensor,pcFiltro)
            changeFilter3(annio,pais,entidad,intervalTipo,interval,1,2,sensor,pcFiltro)

            ref2=`${annio}/${sensor==='modis'?'MODIS':'VIIRS'}`
            if(info3!=undefined){
                ref1=info3['total']
                ref3=`${info['nom_pais']}/${info2['nom_estado']}/${info3['nom_mun']}`
            }else{
                ref1='Sin dato'
                ref3=`${info['nom_pais']}/${info2['nom_estado']}/${toolsMap[0]['municipioNom']}`
            }
        }else{
            if(pais==='1'){
                services=[
                    getTotPais({annio,sensor,pcFiltro}),
                    getTotEstado({annio,pais,estado:entidad,sensor,pcFiltro}),
                    getTotPaisAnp({annio,sensor}),
                    getTotPaisForestal({annio,sensor}),
                    getTotPais({annio,sensor,pcFiltro:'pcalor'})
                ]
                getInfo = await Promise.allSettled(services)
                if(pcFiltro==='anp'){
                    getPaisTotAnp2.set(getInfo[4]['value'])
                    getPaisTotForestal2.set(getInfo[3]['value'])
                }else if(pcFiltro==='forestal'){
                    getPaisTotAnp2.set(getInfo[2]['value'])
                    getPaisTotForestal2.set(getInfo[4]['value'])
                }else{
                    getPaisTotAnp2.set(getInfo[2]['value'])
                    getPaisTotForestal2.set(getInfo[3]['value'])
                }
                info4=getPaisTotAnp.find(item => item['id_pais']==pais)
                ref4=info4['total']
                info5=getPaisTotForestal.find(item => item['id_pais']==pais)
                ref5=info5['total']
            }else{
                services=[
                    getTotPais({annio,sensor,pcFiltro}),
                    getTotEstado({annio,pais,estado:entidad,sensor,pcFiltro})
                ]
                getInfo = await Promise.allSettled(services)
            }
            getPaisTot2.set(getInfo[0]['value'])
            getEntTot2.set(getInfo[1]['value'])
            info=getPaisTot.find(item => item['id_pais']==pais)
            info2=getEntTot.find(item => item['id_estado']==entidad)
            ref1=info['total']
            ref2=`${annio}/${sensor==='modis'?'MODIS':'VIIRS'}`
            ref3=info['nom_pais']

            updatePloty(annio,annioGraf,pais,entidad,municipio,1,sensor,pcFiltro)
            changeFilter3(annio,pais,entidad,intervalTipo,interval,1,1,sensor,pcFiltro)
        }
        if(pcFiltro==='anp'){
            let val1,val4=0
            val1=ref1
            val4=ref4
            ref1=val4
            ref4=val1
        }else if(pcFiltro==='forestal'){
            let val1,val5=0
            val1=ref1
            val5=ref5
            ref1=val5
            ref5=val1
        }
        panelInfo2.set({
            ref1,
            ref2,
            ref3,
            ref4,
            ref5
        })
    }catch(err){
        console.log(err)
    }
}
export const onChangePais = async () => {
    try{
        let getInfo=[]
        let info,info4,info5
        let ref1,ref2,ref3,ref4,ref5=''
        let services=[]
        onChangefilter()
        if(pais==='1'){
            services=[
                getTotEstado({annio,pais,estado:entidad,sensor,pcFiltro}),
                getTotPaisAnp({annio,sensor}),
                getTotPaisForestal({annio,sensor}),
                //getTotEstado({annio,pais,estado:entidad,sensor,pcFiltro:'pcalor'})
            ]
            getInfo = await Promise.allSettled(services)
            if(pcFiltro==='anp'){
                getPaisTotAnp2.set(getInfo[3]['value'])
                getPaisTotForestal2.set(getInfo[2]['value'])
            }else if(pcFiltro==='forestal'){
                getPaisTotAnp2.set(getInfo[1]['value'])
                getPaisTotForestal2.set(getInfo[3]['value'])
            }else{
                getPaisTotAnp2.set(getInfo[1]['value'])
                getPaisTotForestal2.set(getInfo[2]['value'])
            }
            //getPaisTotAnp2.set(getInfo[1]['value'])
            info4=getPaisTotAnp.find(item => item['id_pais']==pais)
            ref4=info4['total']
            //getPaisTotForestal2.set(getInfo[2]['value'])
            info5=getPaisTotForestal.find(item => item['id_pais']==pais)
            ref5=info5['total']
        }else{
            services=[getTotEstado({annio,pais,estado:entidad,sensor,pcFiltro})]
            getInfo = await Promise.allSettled(services)
        }
        ref2=`${annio}/${sensor==='modis'?'MODIS':'VIIRS'}`
        getEntTot2.set(getInfo[0]['value'])
        info=getPaisTot.find(item => item['id_pais']==pais)
        ref1=info['total']
        ref3=`${info['nom_pais']}`
        updatePloty(annio,annioGraf,pais,entidad,municipio,1,sensor,pcFiltro)
        changeBbox(pais)
        deleteIdentify()
        pruebasource(pais)
        findEntidad2('estados', null,'id_estado')
        changeFilter3(annio,pais,entidad,intervalTipo,interval,1,1,sensor,pcFiltro)
        if(pcFiltro==='anp'){
            let val1,val4=0
            val1=ref1
            val4=ref4
            ref1=val4
            ref4=val1
        }else if(pcFiltro==='forestal'){
            let val1,val5=0
            val1=ref1
            val5=ref5
            ref1=val5
            ref5=val1
        }
        panelInfo2.set({
            ref1,
            ref2,
            ref3,
            ref4,
            ref5
        })
    }catch(err){
        console.log(err)
    }
}
export const onChangeEntidad = async () => {
    try{
        let getInfo=[]
        let info,info4,info5
        let ref1,ref2,ref3,ref4,ref5=''
        let services=[]
        onChangefilter()
        if(pais==='1'){
            services=[
                getTotMunicipio({annio,pais,estado:entidad,sensor,pcFiltro}),
                getTotEstado({annio,pais,estado:entidad,sensor,pcFiltro}),
                getTotEstadoAnp({annio,pais,estado:entidad,sensor}),
                getTotEstadoForestal({annio,pais,estado:entidad,sensor}),
                getTotMunicipioAnp({annio,pais,estado:entidad,sensor}),
                getTotMunicipioForestal({annio,pais,estado:entidad,sensor}),
                //getTotMunicipio({annio,pais,estado:entidad,sensor,pcFiltro:'pcalor'}),
            ]
            getInfo = await Promise.allSettled(services)
            getEntTotAnp2.set(getInfo[2]['value'])
            getEntTotForestal2.set(getInfo[3]['value'])

            info4=getEntTotAnp.find(item => item['id_estado']==entidad)
            ref4=info4==undefined?'Sin dato':info4['total']
            info5=getEntTotForestal.find(item => item['id_estado']==entidad)
            ref5=info5['total']
            //getMunTotAnp2.set(getInfo[3]['value'])
            //getMunTotForestal2.set(getInfo[4]['value'])
        }else{
            services=[
                getTotMunicipio({annio,pais,estado:entidad,sensor,pcFiltro}),
                getTotEstado({annio,pais,estado:entidad,sensor,pcFiltro})
            ]
            getInfo = await Promise.allSettled(services)
        }
        //getPaisTot2.set(getInfo[0]['value'])
        getMunTot2.set(getInfo[0]['value'])
        getEntTot2.set(getInfo[1]['value'])
        info=getEntTot.find(item => item['id_estado']==entidad)
        ref1=info['total']
        ref2=`${annio}/${sensor==='modis'?'MODIS':'VIIRS'}`
        ref3=`${info['nom_pais']}/${info['nom_estado']}`
        deleteIdentify()
        updatePloty(annio,annioGraf,pais,entidad,municipio,2,sensor,pcFiltro)
        pruebasource2(pais)
        if(entidadRef!==entidad){
            findEntidad2('estados', entidad,'id_estado')
        }
        entidadRef=entidad
        //findEntidad2('estados', entidad,'id_estado')
        changeBbox2(entidad)
        changeFilter3(annio,pais,entidad,intervalTipo,interval,1,2,sensor,pcFiltro)
        if(pcFiltro==='anp'){
            let val1,val4=0
            val1=ref1
            val4=ref4
            /*ref1=val4
            ref4=val1*/
        }else if(pcFiltro==='forestal'){
            let val1,val5=0
            val1=ref1
            val5=ref5
            /*ref1=val5
            ref5=val1*/
        }
        panelInfo2.set({
            ref1,
            ref2,
            ref3,
            ref4,
            ref5
        })
    }catch(err){
        console.log(err)
    }
}
export const onChangeMunicipio = async () => {
    try{
        let info,info2,info3,info4,info5
        let ref1,ref2,ref3,ref4,ref5=''
        let getInfo=[]
        let services=[]
        onChangefilter()
        //getMunTot2.set(await getTotMunicipio({annio,pais,estado:entidad,sensor,pcFiltro}))
        if(pais==='1'){
            services=[
                getTotMunicipioAnp({annio,pais,estado:entidad,sensor}),
                getTotMunicipioForestal({annio,pais,estado:entidad,sensor}),
                //getTotMunicipio({annio,pais,estado:entidad,sensor,pcFiltro:'pcalor'}),
            ]
            getInfo = await Promise.allSettled(services)
            getMunTotAnp2.set(getInfo[0]['value'])
            getMunTotForestal2.set(getInfo[1]['value'])
            info4=getMunTotAnp.find(item => item['id_mun']==municipio)
            ref4=info4==undefined?'Sin dato':info4['total']
            info5=getMunTotForestal.find(item => item['id_mun']==municipio)
            ref5=info5==undefined?'Sin dato':info5['total']
        }
        info=getPaisTot.find(item => item['id_pais']==pais)
        info2=getEntTot.find(item => item['id_estado']==entidad)
        info3=getMunTot.find(item => item['id_mun']==municipio)
        ref1 = 'Sin dato'
        ref2 = `${annio}/${sensor==='modis'?'MODIS':'VIIRS'}`
        ref3 = `${info['nom_pais']}/${info2['nom_estado']}/${toolsMap[0]['municipioNom']}`
        deleteIdentify()
        /*if(info3!=undefined){
            //setToolsMap('statusPloty',true)
            ref1=info3['total']
        }*/
        if(info3!=undefined){
            ref1=info3['total']
            ref3=`${info['nom_pais']}/${info2['nom_estado']}/${info3['nom_mun']}`
        }else{
            ref1='Sin dato'
            ref3=`${info['nom_pais']}/${info2['nom_estado']}/${toolsMap[0]['municipioNom']}`
        }
        updatePloty(annio,annioGraf,pais,entidad,municipio,3,sensor,pcFiltro)
        findEntidad('estados',municipio,'id_mun')
        panelInfo2.set({
            ref1,
            ref2,
            ref3,
            ref4,
            ref5
        })
    }catch(err){
        console.log(err)
    }
}
export const onChangeSensor = async () => {
    try{
        onChangefilter()
        onChangeAnnio()
    }catch(err){
        console.log(err)
    }
}
export const onChangeGrafica = async () => {
    try{
        onChangefilter()
        if(toolsMap[0]['nivelAdminFilter']===2){
            updatePloty(annio,annioGraf,pais,entidad,municipio,2,sensor,pcFiltro)
        }else if(toolsMap[0]['nivelAdminFilter']===3){
            updatePloty(annio,annioGraf,pais,entidad,municipio,3,sensor,pcFiltro)
        }else{
            updatePloty(annio,annioGraf,pais,entidad,municipio,1,sensor,pcFiltro)
        }
    }catch(err){
        console.log(err)
    }
}
export const onChangeIntervalTipo = async () => {
    try{
        onChangefilter()
        if(entidad==''){
            changeFilter3(annio,pais,entidad,intervalTipo,interval,1,1,sensor,pcFiltro)
        }else{
            changeFilter3(annio,pais,entidad,intervalTipo,interval,1,2,sensor,pcFiltro)
        }
    }catch(err){
        console.log(err)
    }
}
export const onChangeInterval = async () => {
    try{
        onChangefilter()
        if(entidad==''){
            changeFilter3(annio,pais,entidad,intervalTipo,interval,1,1,sensor,pcFiltro)
        }else{
            changeFilter3(annio,pais,entidad,intervalTipo,interval,1,2,sensor,pcFiltro)
        }
    }catch(err){
        console.log(err)
    }
}